import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navbar from "../Navbar";
import taxi from "../belfast-cab-tour-cab-tours.png";
import carrickARede from "../../assets/images/carrick-a-rede-rope-bridge.jpg";
import "../../Styles.css";

const DarkHedges = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollTop(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const tourData = {
    name: "Dark Hedges & Glens of Antrim Taxi Tour",
    description: "Discover the magical landscapes of Northern Ireland on our Dark Hedges and Glens of Antrim taxi tour. Enjoy scenic views, historic landmarks, and photo opportunities.",
    duration: "PT5H", // ISO 8601 duration format
    durationText: "5 hours",
    price: "250",
    currency: "GBP",
    url: "https://belfastcabtour.com/cab-tours/dark-hedges",
    highlights: [
      "Iconic Dark Hedges tree-lined avenue",
      "Stunning Glens of Antrim landscapes",
      "Historic villages and castles along the route",
      "Scenic coastal views and photography opportunities",
    ],
  };

  // JSON-LD structured data for this tour
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": tourData.name,
    "description": tourData.description,
    "touristType": "Sightseeing",
    "touristMode": "https://schema.org/Taxi",
    "duration": tourData.duration,
    "url": tourData.url,
    "offers": {
      "@type": "Offer",
      "price": tourData.price,
      "priceCurrency": tourData.currency,
      "availability": "https://schema.org/InStock",
    },
    "itinerary": {
      "@type": "ItemList",
      "itemListElement": tourData.highlights.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item,
      })),
    },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", margin: 0, padding: 0 }}>
      
      <Helmet>
        {/* SEO Meta Tags */}
        <title>Dark Hedges & Glens of Antrim Taxi Tour | Belfast Cab Tours</title>
        <meta
          name="description"
          content="Discover Northern Ireland on our Dark Hedges and Glens of Antrim taxi tour. Scenic views, historic landmarks, and photo opportunities included."
        />
        <meta
          name="keywords"
          content="Dark Hedges taxi tour, Glens of Antrim tour, Northern Ireland sightseeing, Belfast cab tours, scenic taxi tours"
        />
        <meta name="author" content="Belfast Cab Tour" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={tourData.url} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Dark Hedges & Glens of Antrim Taxi Tour | Belfast Cab Tours" />
        <meta property="og:description" content="Discover Northern Ireland on our Dark Hedges and Glens of Antrim taxi tour. Scenic views, historic landmarks, and photo opportunities included." />
        <meta property="og:url" content={tourData.url} />
        <meta property="og:image" content="https://belfastcabtour.com/belfast-cab-tour-cab-tours.png" />
        <meta property="og:site_name" content="Belfast Cab Tour" />
        <meta property="og:locale" content="en_GB" />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      {/* Navbar */}
      <Navbar />

      {/* Header */}
      <header className="Packages-header" style={{ marginTop: "60px" }}>
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt={tourData.name}
            style={{ top: "-2%", transform: `translateY(-${scrollTop / 100}%)` }}
          />
        </div>
      </header>

      {/* Content Section */}
      <section className="Packages-header1" style={{ textAlign: "center", margin: "40px 20px 20px" }}>
        <h1 style={{ marginBottom: "1em" }}>{tourData.name}</h1>

        <div className="tour-image-container">
         <img 
         src={carrickARede}
         alt={tourData.name}
         className="tour-header-image"
         />
        </div>

        <p style={{ marginBottom: "1em", maxWidth: "600px", margin: "0 auto", paddingBottom: "15px" }}>{tourData.description}</p>

        <p style={{ marginBottom: "1em" }}>
          Duration: <strong>{tourData.durationText}</strong> | Price: <strong>£{tourData.price}</strong> (based on 1-2 passengers)
        </p>

        <p style={{ marginBottom: "1em" }}>Highlights of the tour include:</p>

        <div className="tour-highlights-bullets">
          {tourData.highlights.map((highlight, index) => (
            <p key={index}>{highlight}</p>
          ))}
        </div>

        <p style={{ marginBottom: "1em" }}>
          For personal or bespoke tours, visit our{" "}
          <Link to="/tour-planning-tool" style={{ color: "#ff6f00", textDecoration: "underline" }}>
            Tour Planner
          </Link>{" "}
          to arrange a custom experience tailored to your interests.
        </p>
      </section>

      {/* Tour Card */}
      <div className="tour-grid" style={{ justifyContent: "center" }}>
        <div className="tour-card">
          <div className="tour-card-inner">
            <h2>{tourData.name}</h2>
            <p>Duration: {tourData.durationText}</p>
            <p className="price">£{tourData.price}</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ textAlign: "center", padding: "1rem", backgroundColor: "#333", color: "#fff", marginTop: "auto" }}>
        &copy; 2025 <a href="https://belfastcabtour.com" style={{ color: "#fff", textDecoration: "none" }}>belfastcabtour.com</a>. All rights reserved.
      </footer>
    </div>
  );
};

export default DarkHedges;
